import React, { useState, useEffect, useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import styles from './FONASUPortfolioAllocation.css';
import { shouldValidate, formatFunds } from './utils';
import { CartContext } from '../../context/CartContext/CartContext';
import FONASUAllocationTable from '../FONASUAllocationTable/FONASUAllocationTable';
import FundQuickSearch from '../FundQuickSearch/FundQuickSearch';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';
import EditButton from '../Typography/EditButton/EditButton';
import useCartDetailsState from '../../hooks/useCartDetailsState';

const FONASUPortfolioAllocation = ({
  showSuccess,
  editPortfolio,
  setEditPortfolio,
  allMutualFunds,
  rewardsAvailable,
  taxableJointPortfolios,
  taxableIndividualPortfolios,
  next,
  error
}) => {
  const {
    appState: {
      store: {
        loadedData: { portfolioEditMode }
      }
    }
  } = useContext(FlowContext);

  const {
    totalAmount,
    selectedFunds,
    isValidTotal,
    data = {},
    api: { addFund, fundAdded }
  } = useContext(CartContext);

  const MutualFunds = formatFunds(
    allMutualFunds,
    rewardsAvailable,
    totalAmount
  );

  const [searchableFunds, setSearchableFunds] = useState(MutualFunds);

  useEffect(() => {
    setEditPortfolio(portfolioEditMode);
  }, [portfolioEditMode]);

  useEffect(() => {
    setSearchableFunds(
      formatFunds(allMutualFunds, rewardsAvailable, totalAmount)
    );
  }, [totalAmount, rewardsAvailable, allMutualFunds]);

  const { mutualFunds: mutualFundsWithAllocations = [] } = data;

  const {
    fundsWithCategories,
    validCart,
    validTaxableCart
  } = useCartDetailsState({
    selectedFunds,
    mutualFundsWithAllocations,
    rewardsAvailable,
    totalAmount
  });

  const isValid = shouldValidate(
    selectedFunds,
    editPortfolio,
    validCart,
    validTaxableCart,
    taxableJointPortfolios,
    taxableIndividualPortfolios,
    isValidTotal
  );

  const handleClick = async () => {
    if (isValid) {
      if (editPortfolio) {
        await next({
          section: 'portfolio',
          funds: fundsWithCategories,
          rewardsAvailable
        })();
      } else {
        await next('unlockPortfolioSection')();
      }
    }
  };

  const addSelectedFund = fundText => {
    if (fundText.length > 0) {
      let selectedFund = [...searchableFunds];

      selectedFund = selectedFund.filter(
        ({ name, ticker }) => fundText === `${name} (${ticker})`
      );

      if (selectedFund.length === 1 && !fundAdded(selectedFund[0].ticker)) {
        addFund({
          name: selectedFund[0].name,
          ticker: selectedFund[0].ticker,
          amount: 0,
          percent: 0
        });
      }
    }
  };

  return (
    <div className="review-portfolio">
      <div className="section-header">
        <SectionHeading text="My Portfolio" />
      </div>
      <div className="section-content">
        {editPortfolio && (
          <div className="qv-row">
            <div className="qv-col">
              <FundQuickSearch
                updateFilterText={addSelectedFund}
                allMutualFunds={searchableFunds}
                mode="FONASU-portfolio"
                placeholder="Search for Mutual Funds"
              />
            </div>
          </div>
        )}
        <FONASUAllocationTable
          fundsWithCategories={fundsWithCategories}
          taxableIndividualPortfolios={taxableIndividualPortfolios}
          taxableJointPortfolios={taxableJointPortfolios}
          rewardsAvailable={rewardsAvailable}
          readOnly={!editPortfolio}
        />
      </div>
      <EditButton
        onClick={handleClick}
        currentlyEditing={editPortfolio}
        disabled={!isValid || showSuccess || error !== ''}
      />
      <style jsx>{styles}</style>
    </div>
  );
};

export default FONASUPortfolioAllocation;
